/**
 * Filtered results by provided functions
 * @param {Function[]} listOfFiltersFunctions - list of filter/sort functions
 * @param {Array} array - array of results
 * @result {Array}
 */
export default (listOfFiltersFunctions, array) => {
  let filteredResult = [];
  listOfFiltersFunctions.forEach((filterFunction, index) => {
    if (index === 0) {
      filteredResult = filterFunction(array);
    }
    filteredResult = filterFunction(filteredResult);
  });

  return filteredResult;
};
